import { makeAutoObservable, runInAction } from "mobx"

import notificationAuditLogService from "@services/notification/notificationAuditLogService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  GetNotificationAuditLogInput,
  NotificationAuditLogDto,
} from "@services/notification/dto/notificationAuditLogDto"

/**
 * Store MobX cho Audit Log page (React Portal). Giữ danh sách audit log có phân trang
 * (đã sort CreationTime DESC từ API) + cờ loading; uỷ quyền REST cho `notificationAuditLogService`.
 *
 * Audit log là append-only: chỉ có `getAll` (read) + `export` (tải CSV client-side).
 * Tham chiếu: Requirements 12.3, 12.4, 12.5 (accounting-notification-settings).
 */
class NotificationAuditLogStore {
  /** Danh sách audit log hiển thị + tổng số bản ghi (phục vụ phân trang). */
  tableData: PagedResultDto<NotificationAuditLogDto> = {
    items: [],
    totalCount: 0,
  }
  /** Cờ loading cho danh sách. */
  isLoading = false
  /** Cờ loading riêng cho thao tác export (tránh double-click khi đang tải file). */
  isExporting = false

  constructor() {
    makeAutoObservable(this)
  }

  /** Nạp danh sách audit log theo filter hiện hành (sort CreationTime DESC từ API — R12.3). */
  async getAll(input: GetNotificationAuditLogInput) {
    this.isLoading = true
    try {
      const result = await notificationAuditLogService.getAll(input)
      runInAction(() => {
        this.tableData = result
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  /** Xuất audit log ra CSV với toàn bộ cột theo filter hiện hành (R12.3/12.5). */
  async export(input: GetNotificationAuditLogInput) {
    this.isExporting = true
    try {
      await notificationAuditLogService.export(input)
    } finally {
      runInAction(() => {
        this.isExporting = false
      })
    }
  }
}

export default NotificationAuditLogStore
